import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash, FaStore } from "react-icons/fa";

export default function LoginPage() {
  const { login, pendingUser } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState(pendingUser?.email || "");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [statusMsg, setStatusMsg] = useState(
    pendingUser?.status === "pending"
      ? {
          type: "pending",
          text: `Your registration request for (${pendingUser.email}) is currently pending admin approval. Our team will verify and activate your account shortly.`,
        }
      : null
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setStatusMsg(null);

    if (!email.trim()) return setError("Email is required");
    if (!password) return setError("Password is required");

    setLoading(true);
    try {
      const result = await login(email.trim(), password);

      if (result.success) {
        if (result.isAdmin) {
          navigate("/Dashboard/AddProducts");
        } else {
          navigate("/");
        }
      } else if (result.status === "pending") {
        setStatusMsg({
          type: "pending",
          text: "Your account is pending approval. Our admin team will review your registration shortly.",
        });
      } else if (result.status === "rejected") {
        setStatusMsg({
          type: "rejected",
          text: "Your registration was not approved. Please contact us for more information.",
        });
      }
    } catch (err) {
      if (err.code === "auth/user-not-found" || err.code === "auth/invalid-credential") {
        setError("Invalid email or password. Please try again.");
      } else if (err.code === "auth/wrong-password") {
        setError("Incorrect password. Please try again.");
      } else {
        setError(err.message || "Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo-icon">
          <FaStore />
        </div>
        <h2 className="auth-title">Dealer Login</h2>
        <p className="auth-subtitle">
          Login to see prices and place orders
        </p>

        {error && <div className="auth-error">{error}</div>}

        {statusMsg && (
          <div className={`auth-status-msg auth-status-${statusMsg.type}`}>
            {statusMsg.type === "pending" && "⏳ "}
            {statusMsg.type === "rejected" && "❌ "}
            {statusMsg.text}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <div className="auth-input-icon"><FaEnvelope /></div>
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(""); }}
              required
            />
          </div>

          <div className="auth-field">
            <div className="auth-input-icon"><FaLock /></div>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(""); }}
              required
            />
            <button
              type="button"
              className="auth-eye-btn"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? (
              <span className="auth-spinner" />
            ) : (
              "Login"
            )}
          </button>
        </form>

        <p className="auth-footer-text">
          Don't have an account?{" "}
          <Link to="/register" className="auth-link">
            Register here
          </Link>
        </p>
      </div>
    </div>
  );
}
